const SHOPEE_ECOMMERCE_ID = 3;
const TIKTOK_ECOMMERCE_ID = 1;

const getPatchTargetRequest = (form) => {
  return {
    targetGmv: form?.targetGmv,
    platformTargets: [
      {
        ecommerceId: SHOPEE_ECOMMERCE_ID,
        targetViews: parseInt(form?.targetViewsShopee),
        targetCtr: parseFloat(form?.targetCtrShopee),
        targetCtor: parseFloat(form?.targetCtorShopee),
        targetAov: form?.targetAovShopee,
      },
      {
        ecommerceId: TIKTOK_ECOMMERCE_ID,
        targetViews: parseInt(form?.targetViewsTiktok),
        targetCtr: parseFloat(form?.targetCtrTiktok),
        targetCtor: parseFloat(form?.targetCtorTiktok),
        targetAov: form?.targetAovTiktok,
        targetErr: parseFloat(form?.targetErrTiktok),
      },
    ],
  };
};

export default getPatchTargetRequest;
